import React from 'react'
import PropTypes from 'prop-types'
import {numberPercentFormatter} from '../utils/formatters'

export const CryptoCurrencyDetails = ({ currencyRate: {
	market_cap, conversion_value, volume, daily_diff
} }) => {
	return <div>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>Пазарен дял:</span> { market_cap }</p>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>Курс (BGN):</span> { parseFloat(conversion_value).toFixed(2) }</p>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>Обща Стойност (24ч):</span> { volume }</p>
		<p className='u-margin-none'><span className='u-weight--semi-bold'>Движение (24ч):</span> { numberPercentFormatter(daily_diff) }</p>
	</div>
}

CryptoCurrencyDetails.propTypes = {
	currencyRate: PropTypes.shape({
		market_cap: PropTypes.string,
		conversion_value: PropTypes.string,
		volume: PropTypes.string,
		daily_diff: PropTypes.string
	})
}

export default CryptoCurrencyDetails
